export default __webpack_public_path__ + "static/media/240.919c0dc1.png";